/** Formatting helpers that need no locale catalogue of their own. */

const BYTE_UNITS = ['B', 'KB', 'MB', 'GB'] as const;

/** Sizes with at most one decimal, e.g. "12.4 MB". Locale-aware digits. */
export function formatBytes(bytes: number, locale: string): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < BYTE_UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const digits = unit === 0 || value >= 100 ? 0 : 1;
  const formatted = new Intl.NumberFormat(locale, { maximumFractionDigits: digits }).format(value);
  return `${formatted} ${BYTE_UNITS[unit]}`;
}

/** Whole seconds, for the elapsed counter while a job runs. */
export function seconds(milliseconds: number): number {
  return Math.max(0, Math.round(milliseconds / 1000));
}

/** Parse an ISO 8601 instant, returning null rather than an Invalid Date. */
export function parseInstant(value: string | null | undefined): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Clamp helper used by the link-density slider and the parameter fields. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

/**
 * A filename-safe slug. CJK characters are kept, because a Chinese map name
 * that turns into "journalmap-1" helps nobody; only the characters a filesystem
 * or a Content-Disposition header actually objects to are removed.
 */
export function slugify(name: string): string {
  const cleaned = name
    .replace(/[/\\:*?"<>|]+/g, '')
    .replace(/\s+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');
  return cleaned.slice(0, 80) || 'journalmap';
}
